import { gql } from '@apollo/client'

export const SABRE_MANUFACTURER_FRAGMENT = gql`
  fragment Manufacturer on Manufacturer {
    id
    name
  }
`
